export default "__VITE_ASSET__MLPUlGCt__"